import Dexie, { Table } from "dexie";

interface StoreRelated<T> {
  expireTime?: number;
  value: T;
}

export class CacheDb extends Dexie {
  cache!: Table<StoreRelated<unknown>>;

  constructor() {
    super("CacheDB");

    this.version(1).stores({
      cache: "[id+type+cluster]",
    });
    this.version(2).stores({
      cache: null,
    });
    this.version(3).stores({
      cache: "",
    });
  }
}

export const cacheDb = new CacheDb();
